<template>
  <div class="ktt-form-wrap">
    <el-form :model="self_form" ref="form" :rules="rules" label-width="80px">
      <section>
        <div class="title"><span>团购商品</span></div>
      </section>
      <div class="conf">
        <el-form-item label="名称" prop="goodsName">
          <el-input v-model="self_form.goodsName" placeholder="请输入商品名称">
            <span slot="suffix" style="margin-right: 6px">{{ getBytesCount(self_form.goodsName) }}/120</span>
          </el-input>
        </el-form-item>
        <el-form-item label="商品描述" prop="goodsDesc">
          <el-input type="textarea" v-model="self_form.goodsDesc" :rows="2" placeholder="请输入商品描述">
            <span slot="suffix" style="margin-right: 6px">{{ getBytesCount(self_form.goodsDesc) }}/2000</span>
          </el-input>
        </el-form-item>
        <el-form-item label="商品图片" prop="picUrl">
          <div class="imgs-wrp">
            <div class="">
              铺货时只取主图，拖动可调整顺序
              <BatchEditImages v-model="self_form.picUrl" refName="picUrlRef" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
              ，支持批量对图片添加店铺LOGO、水印、文字、图片等内容
            </div>
            <MutiImgUpload
              ref="picUrlRef"
              v-model="self_form.picUrl"
              v-bind="picUrlLimits"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <p class="tips">
            1. 图片格式支持png/jpg/jpeg，图片尺寸长宽比1:1且宽度为480-1200px，高度1500px以内，单图大小需小于5M<br />
            2. 支持批量传图，最多上传20张图片<br />
          </p>
        </el-form-item>
        <el-form-item label="可购数量" prop="limitBuy">
          <el-input-digit v-model.number="self_form.limitBuy" nullable format="#" style="width: 150px" />
        </el-form-item>
        <el-form-item label="划线价(分)" prop="marketPrice">
          <el-input-digit v-model="self_form.marketPrice" nullable format="#.##" style="width: 150px" />
          <p class="tips">划线价建议高于商品价格</p>
        </el-form-item>
        <el-form-item label="分类" prop="categoryName">
          <el-input v-model="self_form.categoryName" placeholder="请输入分类名" maxlength="30" show-word-limit />
        </el-form-item>
        <el-form-item label="商品规格:" prop="specifications">
          <!-- <RuleSortBtn :specifications.sync="specifications" /> -->
          <FormItemSpecification
            ref="specificationRef"
            :showAddSkuTips="false"
            v-model="specifications"
            :imgLimits="specImgLimits"
            @change="specificationChange"
            @fieldChanged="validateSpecifications"
          />
        </el-form-item>
        <el-form-item label="规格明细:" prop="skuList">
          <FormItemSkuList
            :baseItemId="self_form.baseItemId"
            :specifications="specifications"
            :tableCols="skuTableCols"
            v-model="skuList"
            @fieldChanged="validateSpecifications"
          >
            <template slot="skuOuterIdHeaderSlot">
              <span style="color: red">*</span>商品编码
              <!-- <el-button @click="batchGenSkuOutrerId" type="link">批量生成</el-button> -->
            </template>
          </FormItemSkuList>
          <template v-if="specificationsValidResult !== true">
            <div class="el-form-item__error">{{ specificationsValidResult }}</div>
          </template>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';

import { getBytesCount } from '@utils/data';
import { specification_mixin } from '../../FormItemSpecification';
import validateMixin from '../../validateMixin';
import { prodRules, picUrlLimits, specImgLimits } from '../rules';
import { debounce, cloneDeep } from 'lodash';

export default {
  mixins: [specification_mixin, validateMixin],
  components: { MutiImgUpload, BatchEditImages },
  props: {
    value: {
      type: Object,
      required: true,
    },
    skuTableCols: Array,
    activeIndex: [String, Number],
  },
  data() {
    return {
      getBytesCount,
      platform: 'ktt',
      formKey: 'self_form',
      rules: {},
      specificationsValidResult: true,
      specImgLimits,
      picUrlLimits,
      debouncedValidate: null
    };
  },
  watch: {
    activeIndex: {
      handler(v) {
        this.specifications = this.value.specifications;
        this.skuList = this.value.skuList;
        this.$nextTick(() => {
          this.debouncedValidate && this.debouncedValidate();
        });
      },
      immediate: true,
    },
    skuList: {
      handler(v) {
        const skuList = cloneDeep(v || []).map(sku => {
          const skuS = sku.skuSpecifications.find(skuS => skuS.imageUrl) || {};
          return {...sku, thumbUrl: skuS.imageUrl || ''}
        });
        this.self_form.skuList = skuList;
      },
      deep: true,
    },
  },
  computed: {
    self_form: {
      get() {
        return this.value;
      },
      set(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.value)) {
          this.$emit('input', val);
        }
      },
    },
  },
  methods: {
    specificationChange(specs) {
      this.self_form.specifications = specs;
    },
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
    },
    async _validateAndNotify() {
      const valid = await this.validate();
      if (!valid) {
        this.$message.error('请完善商品内容！');
      }
    },
    // 验证规格图片
    valiSkuImgs() {
      const imgErrMsgs = this.$refs.specificationRef?.imgErrMsgs
      if(imgErrMsgs && Object.values(imgErrMsgs).find(err => err)){
        return false
      }
      return true
    },
    validate() {
      return new Promise(resolve => {
        this.validPage().then(valid => {
          resolve(valid && this.valiSkuImgs());
        });
      });
    },
    // 生成商品编码按钮回调
    // batchGenSkuOutrerId() {
    //   if (!this.self_form.outerId) {
    //     return this.$message.error('请先填写款式编码！');
    //   }
    //   this.$refs.genSkuOuterIdDialog.method_open(
    //     {
    //       skuList: this.$refs.formItemSkuListRef.getRenderList(),
    //       outerId: this.self_form.outerId,
    //     },
    //     skuList => {
    //       this.$refs.formItemSkuListRef.setRenderList(skuList);
    //       this.specificationsFieldChanged();
    //     }
    //   );
    // },
  },
  created() {
    this.debouncedValidate = debounce(this._validateAndNotify, 300);
    this.rules = prodRules(this);
  },
};
</script>

<style scoped>
/* 样式同前 */
</style>